import { AfterViewInit, ChangeDetectorRef, Component, OnDestroy, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { TableDialogService } from '@pg-app/partner/dashboard/services/table-dialog.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'np-dashboard-modal',
  templateUrl: './dashboard-modal.component.html',
  styleUrls: ['./dashboard-modal.component.scss']
})
export class DashboardModalComponent implements OnDestroy, AfterViewInit {
  subscription: Subscription;
  @ViewChild('tabs', {static: true}) tabs;
  data: any;
  activeTabId = '';
  isLoad = false;
  TABS = {
    'Monthly Commission': 'monthly_commission',
    'Recent activity': 'recent_activity',
    'Leads': 'leads',
    'Traded accounts': 'traded_account',
    'In sales process': 'in_sales_process',
    'Converted': 'converted'
  };

  TAB_DATAS = {
    'monthly_commission': null,
    'recent_activity': null,
    'leads': null,
    'traded_account': null,
    'in_sales_process': null,
    'converted': null
  };

  constructor(
    private tableDialogService: TableDialogService,
    private dialog: MatDialog,
    private cdr: ChangeDetectorRef) { }

  ngAfterViewInit() {
    this.subscription = this.tableDialogService.TableTabSelectedSubject.subscribe((data) => {
      const type = this.TABS[data.Type];
      this.TAB_DATAS[type] = data.Data;
      this.isLoad = true;
      this.tabs.select(type);
      this.cdr.detectChanges();
    });
  }

  ngOnDestroy() {
    if (this.subscription) { this.subscription.unsubscribe(); }
  }

  public closeDialog() {
    this.dialog.closeAll();
  }

}
